<template>
<div>
  <div class="order_item" v-show="item.skuImageInfoUrlList.length == 1">
    <div class="order_info" >
      <div class="img">
        <van-image
          @click="showMaxImgFun(item.skuImageInfoUrlList)"
          :src="item.skuImageInfoUrlList[0]"
          width="70"
          height="70"
          fit="cover"
        />
      </div>
      <div class="info">
        <p class="infop1">
          <strong>{{item.branchName}}</strong>
          <span>x{{item.goodsCount}}</span>
        </p>
        <p class="attr">{{item.attributeValues}}</p>
      </div>
    </div> 
    <div class="order_info_desc">共{{item.goodsCount}}件商品，共计<strong>￥{{item.totalPrice}}</strong></div>
  </div>
  <div class="order_item" v-show="item.skuImageInfoUrlList.length>1">
    <div class="order_info_img">
      <van-image
        width="70"
        height="70"
        fit="cover"
        v-for="(t,idx) in item.skuImageInfoUrlList"
        :src="t"
        :key="idx"
        @click="showMaxImgFun(item.skuImageInfoUrlList)"
      />
    </div>
    <div class="order_info_desc">共{{item.goodsCount}}件商品，共计<strong>￥{{item.totalPrice}}</strong></div>
  </div>
</div>
</template>
<script>
import Util from "@/utils/common";
export default {
  name: 'machineItem',
  props: {
    item:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    showMaxImgFun(imgs){
      Util.showMaxImg(encodeURIComponent(JSON.stringify(imgs)), 0);
    },
  },
  created() {
    
  },
  watch:{
    
  },
  destroyed(){
    
  },
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
 .order_item {
  padding: 30px 30px;
  background: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 20px;
  .order_info {
    display: flex;
    .info {
      flex: 1;
      .infop1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 26px;
        span {
          color: #999;
        }
        strong {
          width: 324px;
          color: #333;
          margin-bottom: 25px;
        }
      }
      .attr {
        color: #999999;
        font-size: 24px;
      }
    }

    .img {
      width: 140px;
      height: 140px;
      padding-right: 20px;
    }
  }
  .order_info_img {
    white-space: nowrap;
    flex-wrap: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    .van-image{
      padding-right:15px;
    }
  }
  .order_info_desc{
    font-size:26px;
    text-align: right;
    color:#999;
    strong{
      color:#333;
    }
  }
}
</style>